import React from "react";
import {BreadcrumbContainer, BreadcrumbItemContainer} from "./breadcrumb.styles.js";
function Breadcrumb({
  steps = []
}) {
  return /* @__PURE__ */ React.createElement(BreadcrumbContainer, null, steps.map(({
    name,
    onClick,
    href
  }, index, arr) => {
    const isLast = index + 1 === arr.length;
    return /* @__PURE__ */ React.createElement(BreadcrumbItemContainer, {
      key: name,
      onClick: href || isLast ? void 0 : onClick,
      clickable: (!!onClick || !!href) && !isLast
    }, href ? /* @__PURE__ */ React.createElement("a", {
      href
    }, name) : name);
  }));
}
export default Breadcrumb;
